export default {
  name: 'marking--treeMrkkz',
  apiService: 'shoes',
  apiPath: '/admin/treemrkkz',
};
